import React, { Component } from "react";
import AdvetisementIndex from "../views/advertisements/advetisement-index";

class Advertisement extends Component {
  prefix = "scr_advertisement";

  render() {
    return (
      <div className="container page protection-channel">
        <AdvetisementIndex history={this.props.history} flow={this.props.flow} />
      </div>
    );
  }
}

export default Advertisement;
